<nav class="ptn-nav">
  <a class="ptn-tab" [class.active]="active === 'dashboard'" (click)="dashboardClick.emit()">
    <i class="ti ti-layout-grid"></i>
    Dashboard
  </a>
  <a
    class="ptn-tab"
    *ngIf="showPatientOutcomes"
    [class.active]="active === 'patient-outcomes'"
    (click)="patientOutcomesClick.emit()"
  >
    <i class="ti ti-chart-line"></i>
    Patient Outcomes
  </a>
  <!-- <a
    class="ptn-tab"
    *ngIf="showReferrals"
    [class.active]="active === 'referrals'"
    (click)="referralsClick.emit()"
  >
    <i class="ti ti-arrow-forward-up"></i>
    Referrals
  </a>
  <a
    class="ptn-tab"
    *ngIf="showCompliance"
    [class.active]="active === 'compliance'"
    (click)="complianceClick.emit()"
  >
    <i class="ti ti-circle-check"></i>
    Compliance
  </a> -->
</nav>
